import { Pipe, PipeTransform, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { AlloxCommonAsyncPipe, IAlloxAsyncPipeIDNameList, IAlloxAsyncPipeOption } from './allox-common-async.pipe';
import { Platform, PlatformService } from '@app/core';

interface IPlatformPipeOption extends IAlloxAsyncPipeOption {
  name?: boolean;
  deliveryType?: boolean;
  isPMP?: boolean;
  isSdkDesignTemplateNativeVideo?: boolean;
}

@Pipe({
    name: 'platform', pure: false,
    standalone: false
})
export class PlatformPipe
  extends AlloxCommonAsyncPipe<Platform>
  implements IAlloxAsyncPipeIDNameList<Platform>, PipeTransform {

  constructor(private service: PlatformService, changeDetectorRef: ChangeDetectorRef, router: Router) {
    super(changeDetectorRef, router);
  }

  loadDependency() {
    return this.service.search();
  }

  makeText(value: number, obj: Platform, option?: IPlatformPipeOption) {
    if (!obj) {
      return `Unknown [id: ${value}]`;
    }
    if (option && option.deliveryType) {
      return `${obj.deliveryType}`;
    }
    if (option && option.isPMP) {
      return `${obj.isPMP}`;
    }
    if (option && option.isSdkDesignTemplateNativeVideo) {
      return `${obj.isSdkDesignTemplateNativeVideo}`;
    }
    return obj.name;
  }
}
